module.exports = __webpack_public_path__ + "static/img/join-b.1fb410a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join-b.jpg
// module id = GonE
// module chunks = 1